import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PagoTesoreriaCursoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PagoTesoreriaCursoPage",
            ss: ss,
            ajax: {
                "url": ss.indexPagoTesoreriaCurso(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Curso', name: 'Curso', title: 'Curso' },
                { data: 'PeriodoAcademico', name: 'PeriodoAcademico', title: 'PeriodoAcademico' },
                { data: 'PagoTesoreria', name: 'PagoTesoreria', title: 'Pago Tesoreria' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            pagotesoreriacursos: [],
            pagotesoreriacurso: {},
            nivelesacademicos: [],
            periodosacademicos: [],
            unidadesacademicas: [],
            
            cursos: [],
            filtrosPagoTesoreria:{},
            pagotesoreria: [],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        //////////get unidad academica ////////////////////
        getPagosTesoreria() {
            this.ss.listPagoTesoreria2(this.filtrosPagoTesoreria).then(
                (result) => {
                    let response = result.data;
                    this.pagotesoreria = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get unidad academica ////////////////////
        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadesacademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get nivel academico ////////////////////
        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelesacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get periodo academico ////////////////////
        getPeriodoAcademico() {
            this.ss.listPeriodoAcademico().then(
                (result) => {
                    let response = result.data;
                    this.periodosacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get cursos////////////////////
        getCurso() {
            this.ss.listCurso().then(
                (result) => {
                    let response = result.data;
                    this.cursos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newPagoTesoreriaCurso() {
            this.pagotesoreriacurso = {};
            this.$refs['frm-pagotesoreriacurso'].show();
        },
        showPagoTesoreriaCurso(id) {
            this.isLoading=true;
            this.ss.showPagoTesoreriaCurso(id).then(
                (result) => {
                    let response = result.data;
                    this.pagotesoreriacurso = response.data;
                    this.$refs['view-pagotesoreriacurso'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPagoTesoreriaCurso() {
            this.$refs['frm-pagotesoreriacurso'].show();
            this.$refs['view-pagotesoreriacurso'].hide();
        },
        cancelPagoTesoreriaCurso() {
            if (this.pagotesoreriacurso.id) {
                this.$refs['view-pagotesoreriacurso'].show();
            }
            this.$refs['frm-pagotesoreriacurso'].hide();
        },
        savePagoTesoreriaCurso() {
            this.ss.storePagoTesoreriaCurso(this.pagotesoreriacurso).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-pagotesoreriacurso'].hide();
                    this.$refs['datatable-pagotesoreriacurso'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePagoTesoreriaCurso() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyPagoTesoreriaCurso(this.pagotesoreriacurso)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-pagotesoreriacurso'].hide();
                                this.$refs['datatable-pagotesoreriacurso'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-PagoTesoreriaCurso').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPagoTesoreriaCurso(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            this.getNivelAcademico();
            this.getPeriodoAcademico();
            this.getCurso();
            this.getUnidadAcademica();
            this.getPagosTesoreria();
        }
    }
};
